import "../assets/information/information.css";

const Information = () => {
  const rawHTML = `
<div id="__next">
  <div style="font-family: iranyekan; height: 100%; overflow-y: auto;background-color: #f7f9fc;">
    <header class="Header_hd01__yDeXd">
      <div class="Header_hd02___uFlq">
        <a class="Header_hd05__GVwLn" href="https://avaex.ir"
          ><img
            alt="لوگو آواکس"
            loading="lazy"
            width="40"
            height="40"
            decoding="async"
            data-nimg="1"
            src="../LOGO.png"
            style="color: transparent; cursor: pointer; border-radius: 8px"
          />
          <div class="Header_hd06__eHja_">پلتفرم آواکس</div></a
        >
        <div style="flex: 1"></div>
      </div>
    </header>
    <div style="background-color: #f7f9fc; color: #363636" class="css-1fuqvag">
      <div id="mobile-frame-content" class="css-1c5sxkn">
        <a href="#" font-family="iransans" class="css-b561ax">
          <img
            class="user-pic css-bm5av4"
            src="../LOGO.png"
          />
          <div class="user-info-data css-1eugbva">
            <p class="MuiTypography-root MuiTypography-body1 title css-2wqeg MuiTypography-root MuiTypography-body1 css-11st6xr">
              آواکس
            </p>
            <p
              class="MuiTypography-root MuiTypography-body1 subtitle css-2wqeg MuiTypography-root MuiTypography-body1 css-11st6xr"
            >
              پلتفرم خدمات آنلاین پستی کشور
            </p>
          </div>
        </a>
        <div class="css-izu9g4">
          <div class="css-1qf5gxl">
            <div class="css-1adm55x">
              <div class="css-4ru5p2">
                <p class="MuiTypography-root MuiTypography-body1 css-11st6xr">
                  راه‌های ارتباطی
                </p>
                <div class="css-a4zur5">
                  <div class="css-1rte8m5">
                    <a href="tel:09938347682"
                      style="
                        background-color: #ffffff;
                        border: 1px solid #b1b3b6;
                        color: #007bff !important;
                        border-radius: 15px !important;
                      "
                      data-click-event="block-contact-mobile"
                      data-item-id="c57b40a4-ab85-407c-81b3-77cd5634223c"
                      data-item-index="0"
                      class="css-185e93i"
                    >
                      <div class="css-70dw10">
                      <svg class="icon-mobile css-1cqfowq" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='20px' height='20px'><g fill="none" stroke="#007BFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M16.184 2.75H7.816c-.998 0-1.808.833-1.808 1.86v14.78c0 1.027.81 1.86 1.808 1.86h8.368c.998 0 1.808-.833 1.808-1.86V4.61c0-1.027-.81-1.86-1.808-1.86"/><path d="M12 18.773a.52.52 0 1 0 0-1.038a.52.52 0 0 0 0 1.038M10.003 5.272h3.994"/></g></svg>

                        <p
                          class="MuiTypography-root MuiTypography-body1 css-1g56uc css-pwds3d f-8"
                        >
                          معاونت بازاریابی و فروش (خانم دکتر حسینی)
                        </p>
                      </div>
                      <p
                        class="MuiTypography-root MuiTypography-body1 css-11smftd"
                        hastitle="بازاریابی و فروش 1 (دکتر حسینی)"
                      >
                        ۰۹۹۳۸۳۴۷۶۸۲
                      </p>
                    </a>
                  </div>
                  <div class="css-1rte8m5">
                    <a href="tel:09013532280"
                      style="
                        background-color: #ffffff;
                        border: 1px solid #b1b3b6;
                        color: #007bff !important;
                        border-radius: 15px !important;
                      "
                      data-click-event="block-contact-mobile"
                      data-item-id="52a10b1a-77f5-4215-b301-64f048c6ffc8"
                      data-item-index="1"
                      class="css-185e93i"
                    >
                      <div class="css-70dw10">
                        <svg class="icon-mobile css-1cqfowq" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='20px' height='20px'><g fill="none" stroke="#007BFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M16.184 2.75H7.816c-.998 0-1.808.833-1.808 1.86v14.78c0 1.027.81 1.86 1.808 1.86h8.368c.998 0 1.808-.833 1.808-1.86V4.61c0-1.027-.81-1.86-1.808-1.86"/><path d="M12 18.773a.52.52 0 1 0 0-1.038a.52.52 0 0 0 0 1.038M10.003 5.272h3.994"/></g></svg>
                        <p
                          class="MuiTypography-root MuiTypography-body1 css-1g56uc css-pwds3d f-8"
                        >
                         معاونت عملیات و لجستیک (خانم مهندس نیکبخت)
                        </p>
                      </div>
                      <p
                        class="MuiTypography-root MuiTypography-body1 css-11smftd"
                        hastitle="معاونت عملیات و لجستیک (خانم مهندس نیکبخت)"
                      >
                        ۰۹۰۱۳۵۳۲۲۸۰
                      </p>
                    </a>
                  </div>

                  
                  <div class="css-1rte8m5">
                    <a href="tel:09938851876"
                      style="
                        background-color: #ffffff;
                        border: 1px solid #b1b3b6;
                        color: #007bff !important;
                        border-radius: 15px !important;
                      "
                      data-click-event="block-contact-mobile"
                      data-item-id="52a10b1a-77f5-4215-b301-64f048c6ffc8"
                      data-item-index="1"
                      class="css-185e93i"
                    >
                      <div class="css-70dw10">
                        <svg class="icon-mobile css-1cqfowq" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='20px' height='20px'><g fill="none" stroke="#007BFF" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="M16.184 2.75H7.816c-.998 0-1.808.833-1.808 1.86v14.78c0 1.027.81 1.86 1.808 1.86h8.368c.998 0 1.808-.833 1.808-1.86V4.61c0-1.027-.81-1.86-1.808-1.86"/><path d="M12 18.773a.52.52 0 1 0 0-1.038a.52.52 0 0 0 0 1.038M10.003 5.272h3.994"/></g></svg>
                        <p
                          class="MuiTypography-root MuiTypography-body1 css-1g56uc css-pwds3d f-8"
                        >
                         مدیریت امور نمایندگان (خانم مهندس فرخاری)
                        </p>
                      </div>
                      <p
                        class="MuiTypography-root MuiTypography-body1 css-11smftd"
                        hastitle="مدیریت امور نمایندگان (خانم مهندس فرخاری)"
                      >
                        ۰۹۹۳۸۸۵۱۸۷۶
                      </p>
                    </a>
                  </div>


                  <div class="css-1rte8m5">
                    <a href="tel:02182802466"
                      style="
                        background-color: #ffffff;
                        border: 1px solid #b1b3b6;
                        color: #007bff !important;
                        border-radius: 15px !important;
                      "
                      data-click-event="block-contact-tel"
                      data-item-id="38e1e93b-3a71-4e8e-8f54-73ba440d9889"
                      data-item-index="2"
                      class="css-185e93i"
                    >
                      <div class="css-70dw10">
                      <svg class="icon-phone css-1cqfowq" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='20px' height='20px'><g fill="none"><path stroke="#007BFF" stroke-linecap="round" stroke-width="1.5" d="M13.5 2s2.334.212 5.303 3.182c2.97 2.97 3.182 5.303 3.182 5.303m-7.778-4.949s.99.282 2.475 1.767s1.768 2.475 1.768 2.475"/><path fill="#007BFF" d="m15.1 15.027l-.543-.516zm.456-.48l.544.517zm2.417-.335l-.374.65zm1.91 1.1l-.374.65zm.539 3.446l.543.517zm-1.42 1.496l-.545-.517zm-1.326.71l.074.745zm-9.86-4.489l.543-.516zm-4.813-9.51l-.749.041zm6.475 1.538l.543.517zm.156-2.81l.613-.433zM8.374 3.91l-.613.433zM5.26 3.609l.544.516zM3.691 5.26l-.543-.516zm7.372 7.795l.544-.517zm4.582 2.488l.455-.48l-1.088-1.033l-.455.48zm1.954-.682l1.91 1.1l.749-1.3l-1.911-1.1zm2.279 3.38l-1.42 1.495l1.087 1.034l1.42-1.496zm-2.275 1.975c-1.435.141-5.18.02-9.244-4.258l-1.087 1.033c4.429 4.663 8.654 4.898 10.478 4.717zm-9.244-4.258c-3.876-4.081-4.526-7.523-4.607-9.033l-1.498.08c.1 1.85.884 5.634 5.018 9.986zm1.376-6.637l.286-.302l-1.087-1.033l-.287.302zm.512-4.062L8.986 3.477l-1.225.866l1.26 1.783zm-5.53-2.168L3.149 4.745l1.088 1.033l1.57-1.653zm4.474 5.713a38 38 0 0 0-.545-.515l-.002.002l-.003.003l-.05.058a1.6 1.6 0 0 0-.23.427c-.098.275-.15.639-.084 1.093c.13.892.715 2.091 2.242 3.7l1.088-1.034c-1.428-1.503-1.78-2.428-1.846-2.884c-.032-.22 0-.335.013-.372l.008-.019l-.028.037l-.018.02s-.002 0-.545-.516m1.328 4.767c1.523 1.604 2.673 2.234 3.55 2.377c.451.073.816.014 1.092-.095a1.5 1.5 0 0 0 .421-.25l.036-.034l.014-.014l.007-.006l.003-.003l.001-.002s.002-.001-.542-.518c-.544-.516-.543-.517-.543-.518l.002-.001l.002-.003l.005-.005l.01-.01l.037-.032q.015-.008-.004.001c-.02.008-.11.04-.3.009c-.402-.066-1.27-.42-2.703-1.929zM8.986 3.477C7.972 2.043 5.944 1.8 4.718 3.092l1.087 1.033c.523-.55 1.444-.507 1.956.218zM3.752 6.926c-.022-.4.152-.8.484-1.148L3.148 4.745c-.536.564-.943 1.347-.894 2.261zm14.705 12.811c-.279.294-.57.452-.854.48l.147 1.492c.747-.073 1.352-.472 1.795-.939zM10.021 9.02c.968-1.019 1.036-2.613.226-3.76l-1.225.866c.422.597.357 1.392-.088 1.86zm9.488 6.942c.821.473.982 1.635.369 2.28l1.087 1.033c1.305-1.374.925-3.673-.707-4.613zm-3.409-.898c.385-.406.986-.497 1.499-.202l.748-1.3c-1.099-.632-2.46-.45-3.335.47z"/></g></svg>

                        <p
                          class="MuiTypography-root MuiTypography-body1 css-1g56uc css-pwds3d f-8"
                        >
                          دفتر مرکزی
                        </p>
                      </div>
                      <p
                        class="MuiTypography-root MuiTypography-body1 css-11smftd"
                        hastitle="دفتر مرکزی"
                      >
                        ۰۲۱۸۲۸۰۲۴۶۶
                      </p>
                    </a>
                  </div>


                  

                  <div class="css-1rte8m5">
                    <a href="tel:05137128764"
                      style="
                        background-color: #ffffff;
                        border: 1px solid #b1b3b6;
                        color: #007bff !important;
                        border-radius: 15px !important;
                      "
                      data-click-event="block-contact-tel"
                      data-item-id="38e1e93b-3a71-4e8e-8f54-73ba440d9889"
                      data-item-index="2"
                      class="css-185e93i"
                    >
                      <div class="css-70dw10">
                      <svg class="icon-phone css-1cqfowq" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='20px' height='20px'><g fill="none"><path stroke="#007BFF" stroke-linecap="round" stroke-width="1.5" d="M13.5 2s2.334.212 5.303 3.182c2.97 2.97 3.182 5.303 3.182 5.303m-7.778-4.949s.99.282 2.475 1.767s1.768 2.475 1.768 2.475"/><path fill="#007BFF" d="m15.1 15.027l-.543-.516zm.456-.48l.544.517zm2.417-.335l-.374.65zm1.91 1.1l-.374.65zm.539 3.446l.543.517zm-1.42 1.496l-.545-.517zm-1.326.71l.074.745zm-9.86-4.489l.543-.516zm-4.813-9.51l-.749.041zm6.475 1.538l.543.517zm.156-2.81l.613-.433zM8.374 3.91l-.613.433zM5.26 3.609l.544.516zM3.691 5.26l-.543-.516zm7.372 7.795l.544-.517zm4.582 2.488l.455-.48l-1.088-1.033l-.455.48zm1.954-.682l1.91 1.1l.749-1.3l-1.911-1.1zm2.279 3.38l-1.42 1.495l1.087 1.034l1.42-1.496zm-2.275 1.975c-1.435.141-5.18.02-9.244-4.258l-1.087 1.033c4.429 4.663 8.654 4.898 10.478 4.717zm-9.244-4.258c-3.876-4.081-4.526-7.523-4.607-9.033l-1.498.08c.1 1.85.884 5.634 5.018 9.986zm1.376-6.637l.286-.302l-1.087-1.033l-.287.302zm.512-4.062L8.986 3.477l-1.225.866l1.26 1.783zm-5.53-2.168L3.149 4.745l1.088 1.033l1.57-1.653zm4.474 5.713a38 38 0 0 0-.545-.515l-.002.002l-.003.003l-.05.058a1.6 1.6 0 0 0-.23.427c-.098.275-.15.639-.084 1.093c.13.892.715 2.091 2.242 3.7l1.088-1.034c-1.428-1.503-1.78-2.428-1.846-2.884c-.032-.22 0-.335.013-.372l.008-.019l-.028.037l-.018.02s-.002 0-.545-.516m1.328 4.767c1.523 1.604 2.673 2.234 3.55 2.377c.451.073.816.014 1.092-.095a1.5 1.5 0 0 0 .421-.25l.036-.034l.014-.014l.007-.006l.003-.003l.001-.002s.002-.001-.542-.518c-.544-.516-.543-.517-.543-.518l.002-.001l.002-.003l.005-.005l.01-.01l.037-.032q.015-.008-.004.001c-.02.008-.11.04-.3.009c-.402-.066-1.27-.42-2.703-1.929zM8.986 3.477C7.972 2.043 5.944 1.8 4.718 3.092l1.087 1.033c.523-.55 1.444-.507 1.956.218zM3.752 6.926c-.022-.4.152-.8.484-1.148L3.148 4.745c-.536.564-.943 1.347-.894 2.261zm14.705 12.811c-.279.294-.57.452-.854.48l.147 1.492c.747-.073 1.352-.472 1.795-.939zM10.021 9.02c.968-1.019 1.036-2.613.226-3.76l-1.225.866c.422.597.357 1.392-.088 1.86zm9.488 6.942c.821.473.982 1.635.369 2.28l1.087 1.033c1.305-1.374.925-3.673-.707-4.613zm-3.409-.898c.385-.406.986-.497 1.499-.202l.748-1.3c-1.099-.632-2.46-.45-3.335.47z"/></g></svg>

                        <p
                          class="MuiTypography-root MuiTypography-body1 css-1g56uc css-pwds3d f-8"
                        >
                          امور مشتریان
                        </p>
                      </div>
                      <p
                        class="MuiTypography-root MuiTypography-body1 css-11smftd"
                        hastitle="امور مشتریان"
                      >
                        ۰۵۱۳۷۱۲۸۷۶۴
                      </p>
                    </a>
                  </div>


                  
                  <div class="css-1rte8m5">
                    <a href="mailto:info@avaex.ir"
                      style="
                        background-color: #ffffff;
                        border: 1px solid #b1b3b6;
                        color: #007bff !important;
                        border-radius: 15px !important;
                      "
                      data-click-event="block-contact-email"
                      data-item-id="1d05c02c-13cb-4523-bb24-d5ab9669cd26"
                      data-item-index="3"
                      class="css-185e93i"
                    >
                      <div class="css-70dw10">
                      <svg class="icon-email css-1cqfowq" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='1em' height='1em'><path fill="#007BFF" d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2m-.4 4.25l-7.07 4.42c-.32.2-.74.2-1.06 0L4.4 8.25a.85.85 0 1 1 .9-1.44L12 11l6.7-4.19a.85.85 0 1 1 .9 1.44"/></svg>

                        <p
                          class="MuiTypography-root MuiTypography-body1 css-1g56uc css-pwds3d f-8"
                        >
                          ایمیل روابط عمومی
                        </p>
                      </div>
                      <p
                        class="MuiTypography-root MuiTypography-body1 css-11smftd"
                        hastitle="ایمیل روابط عمومی"
                      >
                        info@avaex.ir
                      </p>
                    </a>
                  </div>
                  <div class="css-1rte8m5">
                    <a href="https://avaex.ir" target="_blank" 
                      style="
                        background-color: #ffffff;
                        border: 1px solid #b1b3b6;
                        color: #007bff !important;
                        border-radius: 15px !important;
                      "
                      data-click-event="block-contact-email"
                      data-item-id="2fee6ee5-bd84-4bd0-99ee-a81ccf4bf6fa"
                      data-item-index="4"
                      class="css-185e93i"
                    >
                      <div class="css-70dw10">
                      <svg class="icon-email css-1cqfowq" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width='1em' height='1em'><path fill="#007BFF" d="M5.86 12.12C6.3 14.44 7.09 16 8 16s1.7-1.56 2.14-3.88zm4.28-8.24C9.7 1.56 8.91 0 8 0S6.3 1.56 5.86 3.88zm5.32 7a8 8 0 0 0 0-5.76h-3.88A25 25 0 0 1 11.75 8a25 25 0 0 1-.17 2.88zm-5.13-5.76H5.67a24.5 24.5 0 0 0 0 5.76h4.66A24 24 0 0 0 10.5 8a24 24 0 0 0-.17-2.88M4.25 8a25 25 0 0 1 .17-2.88H.54a8 8 0 0 0 0 5.76h3.88A25 25 0 0 1 4.25 8m7.15 4.12a11.2 11.2 0 0 1-1.15 3.55a8 8 0 0 0 4.6-3.55zm0-8.24h3.45a8 8 0 0 0-4.6-3.55a11.2 11.2 0 0 1 1.15 3.55m-6.8 8.24H1.15a8 8 0 0 0 4.6 3.55a11.2 11.2 0 0 1-1.15-3.55m0-8.24A11.2 11.2 0 0 1 5.75.33a8 8 0 0 0-4.6 3.55z"/></svg>

                        <p
                          class="MuiTypography-root MuiTypography-body1 css-1g56uc css-pwds3d f-8"
                        >
                          وبسایت
                        </p>
                      </div>
                      <p
                        class="MuiTypography-root MuiTypography-body1 css-11smftd"
                        hastitle="وبسایت"
                      >
                        https://avaex.ir
                      </p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="css-izu9g4">
          <div class="css-1qf5gxl">
            <div class="css-1adm55x">
              <div class="css-4ru5p2">
                <div class="css-a4zur5">
                  <div class="css-1rte8m5">
                    <a href="https://eitaa.com/avaexir" target="_blank"
                      style="
                        background-color: rgb(197 197 197);
                        border: 1px solid #b1b3b6;
                        color: #4d4d4d !important;
                        border-radius: 15px !important;
                      "
                      data-click-event="block-messengers-eitaa"
                      data-item-id="9ed92737-772e-4762-b1df-57f412535f52"
                      data-item-index="0"
                      class="css-185jeai"
                    >
                      <div class="css-14bktdw">
                        <svg class="icon-eita-color css-6v9ouw" height="20px" viewBox="5.312 -.192 501.099 512.323" width="20px" xmlns="http://www.w3.org/2000/svg"><path d="m127.317 510.763a141.312 141.312 0 0 1 -49.749-17.707c-34.56-19.819-60.352-55.317-68.629-94.421-3.221-15.296-3.627-34.624-3.2-153.749.405-128.193.106-121.579 6.208-142.699 3.029-10.517 11.456-28.587 17.557-37.696 22.507-33.494 55.616-54.998 96.64-62.784 8.192-1.557 20.053-1.707 129.195-1.707 133.355 0 128.96-.192 150.741 6.699a145.216 145.216 0 0 1 92.032 89.259c7.04 19.989 7.381 23.189 7.872 75.84l.427 47.573-8.341 5.717c-11.904 8.128-27.52 22.613-49.408 45.867-25.216 26.795-50.688 51.627-63.616 62.016-27.925 22.421-53.504 35.221-79.488 39.765-13.525 2.347-35.883 1.429-49.109-2.027-11.797-3.072-11.029-3.584-15.488 9.899a135.573 135.573 0 0 0 -6.784 32.981l-.661 8.683-3.115-.64c-25.92-5.141-51.605-27.413-61.525-53.333a76.437 76.437 0 0 1 -5.547-26.005l-.341-7.253-6.592-6.059c-13.739-12.587-22.677-27.989-25.493-43.968-4.523-25.451 7.253-54.229 32.811-80.128 26.965-27.371 66.709-48.853 105.664-57.173 14.037-2.987 38.784-3.776 51.264-1.6 24.277 4.224 44.096 16.491 56.427 34.965 3.883 5.781 4.16 6.613 3.776 11.84a17.323 17.323 0 0 1 -3.904 10.517c-9.92 13.888-39.424 28.757-71.168 35.84-56 12.48-91.605-3.029-86.037-37.525.555-3.477.853-6.485.661-6.677-.683-.683-6.251 2.219-12.267 6.4-10.219 7.125-19.264 20.992-22.4 34.283-.768 3.328-1.067 8.661-.725 13.867.427 7.061 1.131 9.685 4.096 15.701 1.963 3.968 5.867 9.6 8.704 12.565l5.12 5.355-2.048 2.603a103.36 103.36 0 0 0 -14.443 25.963 77.547 77.547 0 0 0 -2.24 38.72c2.197 9.835 8.981 23.36 15.765 31.317 5.163 6.08 17.003 16.299 18.901 16.299.512 0 .939-1.024.939-2.261.021-4.907 3.925-20.757 6.955-28.309 9.024-22.571 28.821-41.813 60.16-58.453 5.227-2.773 20.309-10.027 33.536-16.149 29.013-13.44 44.864-21.653 53.568-27.84 25.088-17.771 40.597-44.053 45.653-77.333 1.835-12.16 1.835-34.859 0-47.083-7.851-52.011-46.827-87.381-102.784-93.227-62.4-6.549-141.824 41.664-190.763 115.776-23.808 36.053-39.893 76.053-46.656 116.117-2.624 15.531-3.605 44.373-1.984 58.667 4.117 36.352 17.536 65.664 40.597 88.661a139.328 139.328 0 0 0 39.893 28.011c50.517 24.107 106.453 24.64 155.627 1.515 21.248-10.005 42.112-25.515 64.491-48 21.76-21.867 36.48-40.107 76.629-95.104 22.187-30.357 39.765-50.517 48.469-55.573l3.2-1.835-.405 65.941c-.384 63.851-.469 66.283-2.624 75.968-12.8 57.131-54.187 98.901-110.827 111.829l-9.984 2.283-123.2.213c-100.992.171-124.8-.043-132.053-1.195z" fill="#e37600"/></svg>

                      </div>
                      <p
                        class="MuiTypography-root MuiTypography-body1 css-pwds3d"
                      >
                        ایتا
                      </p>
                    </a>
                  </div>
                  <div class="css-1rte8m5">
                    <a href="https://wa.me/+989938347682" target="_blank"
                      style="
                        background-color: rgb(197 197 197);
                        border: 1px solid #b1b3b6;
                        color: #4d4d4d !important;
                        border-radius: 15px !important;
                      "
                      data-click-event="block-messengers-whatsapp"
                      data-item-id="55b087e7-e492-4a96-a14a-9b1924767f87"
                      data-item-index="1"
                      class="css-orflql"
                    >
                      <div class="css-14bktdw">
                        <svg class="icon-whatsapp css-vy71" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 258 256" width='1em' height='1em'><defs><linearGradient id="logosWhatsappIcon0" x1="50%" x2="50%" y1="100%" y2="0%"><stop offset="0%" stop-color="#1FAF38"/><stop offset="100%" stop-color="#60D669"/></linearGradient><linearGradient id="logosWhatsappIcon1" x1="50%" x2="50%" y1="100%" y2="0%"><stop offset="0%" stop-color="#F9F9F9"/><stop offset="100%" stop-color="#FFF"/></linearGradient></defs><path fill="url(#logosWhatsappIcon0)" d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a123 123 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004"/><path fill="url(#logosWhatsappIcon1)" d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z"/><path fill="#FFF" d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561s11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716s-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64"/></svg>
                      </div>
                      <p
                        class="MuiTypography-root MuiTypography-body1 css-pwds3d"
                      >
                        واتس‌اپ
                      </p>
                    </a>
                  </div>
                  <div class="css-1rte8m5">
                    <a href="https://t.me/avaexdigital" target="_blank"
                      style="
                        background-color: rgb(197 197 197);
                        border: 1px solid #b1b3b6;
                        color: #4d4d4d !important;
                        border-radius: 15px !important;
                      "
                      data-click-event="block-messengers-telegram"
                      data-item-id="b05f5870-cb3d-4866-bf00-770a0c7b8e53"
                      data-item-index="2"
                      class="css-1rf9ut9"
                    >
                      <div class="css-14bktdw">
                        <svg class="icon-telegram css-1wc4rpz" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width='1em' height='1em'><defs><linearGradient id="logosTelegram0" x1="50%" x2="50%" y1="0%" y2="100%"><stop offset="0%" stop-color="#2AABEE"/><stop offset="100%" stop-color="#229ED9"/></linearGradient></defs><path fill="url(#logosTelegram0)" d="M128 0C94.06 0 61.48 13.494 37.5 37.49A128.04 128.04 0 0 0 0 128c0 33.934 13.5 66.514 37.5 90.51C61.48 242.506 94.06 256 128 256s66.52-13.494 90.5-37.49c24-23.996 37.5-56.576 37.5-90.51s-13.5-66.514-37.5-90.51C194.52 13.494 161.94 0 128 0"/><path fill="#FFF" d="M57.94 126.648q55.98-24.384 74.64-32.152c35.56-14.786 42.94-17.354 47.76-17.441c1.06-.017 3.42.245 4.96 1.49c1.28 1.05 1.64 2.47 1.82 3.467c.16.996.38 3.266.2 5.038c-1.92 20.24-10.26 69.356-14.5 92.026c-1.78 9.592-5.32 12.808-8.74 13.122c-7.44.684-13.08-4.912-20.28-9.63c-11.26-7.386-17.62-11.982-28.56-19.188c-12.64-8.328-4.44-12.906 2.76-20.386c1.88-1.958 34.64-31.748 35.26-34.45c.08-.338.16-1.598-.6-2.262c-.74-.666-1.84-.438-2.64-.258c-1.14.256-19.12 12.152-54 35.686c-5.1 3.508-9.72 5.218-13.88 5.128c-4.56-.098-13.36-2.584-19.9-4.708c-8-2.606-14.38-3.984-13.82-8.41c.28-2.304 3.46-4.662 9.52-7.072"/></svg>
                      </div>
                      <p
                        class="MuiTypography-root MuiTypography-body1 css-pwds3d"
                      >
                        تلگرام
                      </p>
                    </a>
                  </div>
                  
                  <div class="css-1rte8m5">
                    <a href="https://www.instagram.com/avaex.ir" target="_blank"
                      style="
                        background-color: rgb(197 197 197);
                        border: 1px solid #b1b3b6;
                        color: #4d4d4d !important;
                        border-radius: 15px !important;
                      "
                      data-click-event="block-socialNetworks-instagram"
                      data-item-id="e4cc6771-a587-4c05-9de1-319617c5a23b"
                      data-item-index="0"
                      class="css-j465ig"
                    >
                      <div class="css-14bktdw">
                        <svg class="icon-instagram css-1hy60pu" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" width='1em' height='1em'><g fill="none"><rect width="256" height="256" fill="url(#skillIconsInstagram0)" rx="60"/><rect width="256" height="256" fill="url(#skillIconsInstagram1)" rx="60"/><path fill="#fff" d="M128.009 28c-27.158 0-30.567.119-41.233.604c-10.646.488-17.913 2.173-24.271 4.646c-6.578 2.554-12.157 5.971-17.715 11.531c-5.563 5.559-8.98 11.138-11.542 17.713c-2.48 6.36-4.167 13.63-4.646 24.271c-.477 10.667-.602 14.077-.602 41.236s.12 30.557.604 41.223c.49 10.646 2.175 17.913 4.646 24.271c2.556 6.578 5.973 12.157 11.533 17.715c5.557 5.563 11.136 8.988 17.709 11.542c6.363 2.473 13.631 4.158 24.275 4.646c10.667.485 14.073.604 41.23.604c27.161 0 30.559-.119 41.225-.604c10.646-.488 17.921-2.173 24.284-4.646c6.575-2.554 12.146-5.979 17.702-11.542c5.563-5.558 8.979-11.137 11.542-17.712c2.458-6.361 4.146-13.63 4.646-24.272c.479-10.666.604-14.066.604-41.225s-.125-30.567-.604-41.234c-.5-10.646-2.188-17.912-4.646-24.27c-2.563-6.578-5.979-12.157-11.542-17.716c-5.562-5.562-11.125-8.979-17.708-11.53c-6.375-2.474-13.646-4.16-24.292-4.647c-10.667-.485-14.063-.604-41.23-.604zm-8.971 18.021c2.663-.004 5.634 0 8.971 0c26.701 0 29.865.096 40.409.575c9.75.446 15.042 2.075 18.567 3.444c4.667 1.812 7.994 3.979 11.492 7.48c3.5 3.5 5.666 6.833 7.483 11.5c1.369 3.52 3 8.812 3.444 18.562c.479 10.542.583 13.708.583 40.396s-.104 29.855-.583 40.396c-.446 9.75-2.075 15.042-3.444 18.563c-1.812 4.667-3.983 7.99-7.483 11.488c-3.5 3.5-6.823 5.666-11.492 7.479c-3.521 1.375-8.817 3-18.567 3.446c-10.542.479-13.708.583-40.409.583c-26.702 0-29.867-.104-40.408-.583c-9.75-.45-15.042-2.079-18.57-3.448c-4.666-1.813-8-3.979-11.5-7.479s-5.666-6.825-7.483-11.494c-1.369-3.521-3-8.813-3.444-18.563c-.479-10.542-.575-13.708-.575-40.413s.096-29.854.575-40.396c.446-9.75 2.075-15.042 3.444-18.567c1.813-4.667 3.983-8 7.484-11.5s6.833-5.667 11.5-7.483c3.525-1.375 8.819-3 18.569-3.448c9.225-.417 12.8-.542 31.437-.563zm62.351 16.604c-6.625 0-12 5.37-12 11.996c0 6.625 5.375 12 12 12s12-5.375 12-12s-5.375-12-12-12zm-53.38 14.021c-28.36 0-51.354 22.994-51.354 51.355s22.994 51.344 51.354 51.344c28.361 0 51.347-22.983 51.347-51.344c0-28.36-22.988-51.355-51.349-51.355zm0 18.021c18.409 0 33.334 14.923 33.334 33.334c0 18.409-14.925 33.334-33.334 33.334s-33.333-14.925-33.333-33.334c0-18.411 14.923-33.334 33.333-33.334"/><defs><radialGradient id="skillIconsInstagram0" cx="0" cy="0" r="1" gradientTransform="matrix(0 -253.715 235.975 0 68 275.717)" gradientUnits="userSpaceOnUse"><stop stop-color="#FD5"/><stop offset=".1" stop-color="#FD5"/><stop offset=".5" stop-color="#FF543E"/><stop offset="1" stop-color="#C837AB"/></radialGradient><radialGradient id="skillIconsInstagram1" cx="0" cy="0" r="1" gradientTransform="matrix(22.25952 111.2061 -458.39518 91.75449 -42.881 18.441)" gradientUnits="userSpaceOnUse"><stop stop-color="#3771C8"/><stop offset=".128" stop-color="#3771C8"/><stop offset="1" stop-color="#60F" stop-opacity="0"/></radialGradient></defs></g></svg>
                      </div>
                      <p
                        class="MuiTypography-root MuiTypography-body1 css-pwds3d"
                      >
                        اینستاگرام
                      </p>
                    </a>
                  </div>
                  <div class="css-1rte8m5">
                    <a href="https://back.avaex.ir/avaex.apk" target="_blank"
                      style="
                        background-color: rgb(197 197 197);
                        border: 1px solid #b1b3b6;
                        color: #4d4d4d !important;
                        border-radius: 15px !important;
                      "
                      data-click-event="block-socialNetworks-myket"
                      data-item-id="40ca99ee-ad06-4dde-8ede-f6945de1c214"
                      data-item-index="1"
                      class="css-1gf2s19"
                    >
                      <div class="css-14bktdw">
                      <svg class="icon-myket-color css-6v9ouw" version="1.1" width="1em" height="1em" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        viewBox="222 -264.9 700 700" style="enable-background:new 222 -264.9 700 700;" xml:space="preserve">
                        <g id="XMLID_46_">
                          <g id="XMLID_45_">
                            <g id="XMLID_58_">
                              <circle id="XMLID_62_" fill="#0091EA" cx="572" cy="85.1" r="334.7"/>
                              <g id="XMLID_59_">
                                <path id="XMLID_61_" fill="#FFFFFF" d="M777.3,45.5c-2.8-63.4-54.9-113.7-118.9-113.7c-35.5,0-67.5,15.7-89.3,40.3
                                  c-21.8-24.6-53.8-40.3-89.3-40.3c-62.7,0-114.1,48.3-118.7,110.2c-0.2,1.3-0.2,3-0.2,4.6v134.3c0,16.5,13.3,29.8,29.8,29.8h0.7
                                  c16.5,0,29.8-13.3,29.8-29.8v-130h0.2c0-32.7,26.6-59.2,59.2-59.2c32.7,0,59.2,26.6,59.2,59.2h0.2v109.7
                                  c0,16.5,13.3,29.8,29.8,29.8h0.7c16.5,0,29.8-13.3,29.8-29.8v-110c0.2-32.7,26.6-58.8,59.2-58.8S719,18.5,719,51.1h0.2v130.2
                                  c0,16.3,13.3,29.4,29.4,29.4h0.7c16.3,0,29.4-13.3,29.4-29.4V48.5C777.3,47,777.3,46.3,777.3,45.5z"/>
                                <path id="XMLID_60_" fill="#FFFFFF" d="M664.8,222.3c-1.3-2.2-5.7,2.2-5.7,2.2c-16.5,17.9-50.7,29.4-86.2,29.4
                                  s-69.5-11.5-86.2-29.4c0,0-4.4-4.6-5.7-2.2c-1.7,2.6,0.9,6.8,0.9,6.8c21.1,30.5,53.3,44.2,91,44.2c37.7,0,69.9-13.7,91-44.2
                                  C664.1,229,666.5,224.9,664.8,222.3z"/>
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>

                      </div>
                      <p
                        class="MuiTypography-root MuiTypography-body1 css-pwds3d"
                      >
                        دانلود اپلیکیشن آواکس از مایکت
                      </p>
                    </a>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="css-izu9g4">
          <div class="css-1qf5gxl">
            <div class="css-1adm55x">
              <div class="css-p9b141">
                <p class="MuiTypography-root MuiTypography-body1 css-1qmo0vq">
                  لینک‌های مفید
                </p>
                <a
                  href="https://cv.avaex.ir/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="
                    background-color: #007bff;
                    border: 1px solid #b1b3b6;
                    color: #ffffff !important;
                    border-radius: 15px !important;
                    font-size: 0.9rem !important;
                  "
                  data-click-event="block-link"
                  data-item-id="0349d033-b157-46d6-97f8-1705c45cadca"
                  data-item-index="0"
                  class="css-pyfb3b"
                  >رزومه شرکت eBook
                  
                  <svg class="icon-download-3 css-1xjh4mh" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='1em' height='1em'><path fill="currentColor" d="M20 11a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1"/><path fill="currentColor" d="M16 5h1.58l-6.29 6.28a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0L19 6.42V8a1 1 0 0 0 1 1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2"/></svg>
                </a>
                <a
                  href="https://avaex.ir/developers"
                  target="_blank"
                  rel="noopener noreferrer"
                  style="
                    background-color:rgb(37, 37, 37);
                    border: 1px solid #b1b3b6;
                    color: #ffffff !important;
                    border-radius: 15px !important;
                    font-size: 0.9rem !important;
                  "
                  data-click-event="block-link"
                  data-item-id="0349d033-b157-46d6-97f8-1705c45cadca"
                  data-item-index="0"
                  class="css-pyfb3b">
                  توسعه دهندگان (ابزارها و منابع کاربردی)
                  <svg class="icon-download-3 css-1xjh4mh" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width='1em' height='1em'><path fill="currentColor" d="M20 11a1 1 0 0 0-1 1v6a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h6a1 1 0 0 0 0-2H6a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3v-6a1 1 0 0 0-1-1"/><path fill="currentColor" d="M16 5h1.58l-6.29 6.28a1 1 0 0 0 0 1.42a1 1 0 0 0 1.42 0L19 6.42V8a1 1 0 0 0 1 1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2"/></svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="css-izu9g4">
          <div class="css-1qf5gxl">
            <div class="css-1adm55x">
              <a
                target="_blank"
                rel="noopener noreferrer"
                class="css-1j81ojk"
                data-click-event="block-banner-image"
                data-item-id="3a3f52cb-0358-46fd-97cb-feba06a78c4a"
                ><img
                  src="../images/information/info.jpg"
                  alt="892693"
                  style="
                    background-color: initial;
                    border: none;
                    color: initial !important;
                    border-radius: 15px !important;
                  "
                  class="css-1ecbjsz"
              /></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>



  `;

  return (
    <div
      className="information-page"
      dangerouslySetInnerHTML={{ __html: rawHTML }}
    />
  );
};

export default Information;
